import React from 'react'
import Helmet from 'react-helmet'

import Work from '../components/work'

const winston = require('../img/winston2.jpg')

const Winston = () =>
  <div>

    <Helmet
      title='Winston | Cory Schadt'
      bodyAttributes={{
        class: 'inner'
      }}
    />

    <div className='page fade'>
      <div className='container'>
        <div className='content'>
          <h1>Winston</h1>
          <div className='text'>
            <p>Winston is platform for that allows Instagram users to connect with some of the biggest brands in the world.
            </p>
            <p>Primary Role:  HTML, CSS, Responsive Design, React Component Creation.</p>
            <p><a className='btn' target='_blank' href='http://winston.social'>View Project</a></p>
          </div>
        </div>
      </div>

      <div className='project-feature'>

        <Work noLink raise laptop screen={winston} color='#2FB9F9' />

      </div>

    </div>
  </div>
export default Winston



// WEBPACK FOOTER //
// ./src/pages/winston.js